import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e8f2f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cash_on_deliveries_filters = _resolveComponent("cash-on-deliveries-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_update)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: "Редактирование данных",
          loading: _ctx.state.is_loading,
          onCancel: _ctx.toggleUpdate,
          onConfirm: _ctx.updateCashOnDeliveries
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              placeholder: "НП фактический принятый курьером",
              disabled: _ctx.state.is_loading,
              value: _ctx.state.actualPayment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.actualPayment) = $event)),
              "is-invalid": !_ctx.state.actualPayment,
              type: "number"
            }, null, 8, ["disabled", "value", "is-invalid"]),
            _createVNode(_component_the_input, {
              class: "mt-2",
              placeholder: "НП перечисленный заказчику",
              disabled: _ctx.state.is_loading,
              value: _ctx.state.clientAmount,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.clientAmount) = $event)),
              type: "number"
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_the_input, {
              class: "mt-2",
              placeholder: "Дата перечисления заказчику",
              disabled: _ctx.state.is_loading,
              value: _ctx.state.clientDate,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.clientDate) = $event)),
              type: "datetime-local"
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_checkbox, {
              value: _ctx.state.isCash,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.isCash) = $event)),
              disabled: _ctx.state.is_loading,
              label: "Наличка",
              "return-integer": "",
              class: "mt-2"
            }, null, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, {
        title: "Отчеты по НП",
        class: "mb-6"
      }),
      _createVNode(_component_cash_on_deliveries_filters, {
        loading: _ctx.state.cash_on_deliveries.is_loading,
        onSearch: _ctx.applyFilters,
        onReset: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onReset"]),
      _createElementVNode("div", _hoisted_2, [
        (
                    _ctx.state.cash_on_deliveries.is_failed &&
                    !_ctx.state.cash_on_deliveries.failure.error_state.is_cancel
                )
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.cash_on_deliveries.is_loading,
              text: "При получении списка произошла ошибка",
              "error-message": _ctx.state.cash_on_deliveries.failure.error_state.message,
              "error-url": _ctx.state.cash_on_deliveries.failure.error_state.url,
              "error-status": _ctx.state.cash_on_deliveries.failure.error_state.status,
              onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCashOnDeliveries(_ctx.state.cash_on_deliveries.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_table_scroll_wrapper, {
                loading: _ctx.state.cash_on_deliveries.is_loading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_table, {
                    loading: _ctx.state.cash_on_deliveries.is_loading,
                    columns: _ctx.CashOnDeliveriesColumns,
                    rows: _ctx.state.cash_on_deliveries.list,
                    "with-limit": "",
                    "pagination-limit": _ctx.state.limit,
                    "pagination-total-items": _ctx.state.cash_on_deliveries.pagination.total_items,
                    "pagination-current-page": _ctx.state.cash_on_deliveries.pagination.current_page,
                    "pagination-total-pages": _ctx.state.cash_on_deliveries.pagination.total_pages,
                    onChangePage: _ctx.loadCashOnDeliveries,
                    onChangeLimit: _ctx.onLimitChange
                  }, {
                    buttons: _withCtx(() => [
                      _createVNode(_component_the_button, {
                        class: "primary text small mr-2",
                        onClick: _ctx.exportExcel,
                        loading: _ctx.state.cash_on_deliveries.is_loading,
                        hint: "Экспортировать"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ]),
                    td: _withCtx(({ row, column }) => [
                      (column.key === 'companyName' && row.companyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/companies/${row.companyId}`,
                            class: "text-blue-500",
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.companyName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (column.key === 'orderNumber' && row.orderId)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: `/order/${row.orderId}`,
                              class: "text-blue-500",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.orderNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (column.key === 'invoiceNumber' && row.id)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: `/invoice/${row.id}`,
                                class: "text-blue-500",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.invoiceNumber), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (column.key === 'statusName')
                              ? (_openBlock(), _createBlock(_component_cheap, {
                                  key: 3,
                                  class: _normalizeClass(["small font-bold", _ctx.getCheapClass(row.statusId)])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.cutName(row.statusName, 12)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ], 64))
                    ]),
                    actions: _withCtx(({ row }) => [
                      (
                                    _ctx.havePermissions([
                                        'order-cash-on-deliveries-update',
                                        'all-root-permission',
                                    ])
                                )
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            class: "primary small",
                            loading: _ctx.state.is_loading,
                            onClick: ($event: any) => (_ctx.toggleUpdate(row)),
                            hint: "Редактировать"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                ]),
                _: 1
              }, 8, ["loading"])
            ]))
      ])
    ])
  ], 64))
}